import { clsx } from 'clsx';
import { Button } from 'src/components/ui/button';
import React from 'react';
import { Link } from 'react-router-dom';
import { GoToIcon } from 'src/assets/icons/goToIcon';

export const GoToButton = ({ onClick = () => {}, className = '', href = '' }) => {
  return (
    <Link to={href}>
      <Button
        variant="outline"
        size="sm"
        className={clsx('shadow-search gap-2 p-2.5', className)}
        onClick={onClick}
      >
        <GoToIcon />
      </Button>
    </Link>
  );
};
